import { Formik, Form } from 'formik';
import PropTypes from 'prop-types';
import React, { useState, useContext } from 'react';
import * as Yup from 'yup';

import TextInput from '@atoms/TextInput';
import { LoadingContext } from '@context/LoadingProvider';
import { searchMemberByEmail } from '@general/api/memberAPI';

const MembershipSearchByEmailForm = ({ onSearchCompleted, onSubmittingChange }) => {
    const { setIsLoading } = useContext(LoadingContext);
    const [lastSubmittedEmail, setLastSubmittedEmail] = useState('');

    const validateAndSubmit = async ({ email, setTouched, validateForm }) => {
        setTouched({ email: true });
        const errors = await validateForm();

        if (email && !errors.email) {
            search({ email });
        }
    };

    const search = async ({ email }) => {
        if (email === lastSubmittedEmail) {
            return;
        }

        setIsLoading(true);
        onSubmittingChange(true);
        setLastSubmittedEmail(email);

        try {
            const encodedEmail = encodeURIComponent(email);
            const response = await searchMemberByEmail({ email: encodedEmail });
            setIsLoading(false);
            onSubmittingChange(false);
            onSearchCompleted({ email, count: response.data?.data?.count });
        } catch (error) {
            setIsLoading(false);
            onSubmittingChange(false);
            console.log('error', error);
        }
    };

    return (
        <Formik
            initialValues={{
                email: '',
            }}
            validateOnBlur
            validateOnChange={false}
            validationSchema={Yup.object({
                email: Yup.string().email('Invalid email address'),
            })}
        >
            {({ values, setTouched, validateForm }) => {
                return (
                    <Form>
                        <TextInput
                            name="email"
                            placeholder="Email Address"
                            type="email"
                            onBlur={async () => {
                                validateAndSubmit({ email: values.email, setTouched, validateForm });
                            }}
                            onKeyDown={async event => {
                                if (event.key === 'Enter') {
                                    event.preventDefault();
                                    validateAndSubmit({ email: values.email, setTouched, validateForm });
                                }
                            }}
                        />
                    </Form>
                );
            }}
        </Formik>
    );
};

MembershipSearchByEmailForm.propTypes = {
    onSearchCompleted: PropTypes.func.isRequired,
    onSubmittingChange: PropTypes.func.isRequired,
};

export default MembershipSearchByEmailForm;
